module.exports = __webpack_public_path__ + "static/img/2.bba9755.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/2.png
// module id = soW/
// module chunks = 0